import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useUserInfor } from "../../../../../Context/User";
import { CadastrarContatoController } from "../../../../../Controllers/Geral/Contatos/ContatosController";
import { GetCidadeController } from "../../../../../Controllers/Geral/Endereco/Cidade/CidadeControllers";
import { ListarEstadosController } from "../../../../../Controllers/Geral/Endereco/Estado/EstadoControllers";
import { ListarClientesController } from "../../../../../Controllers/Geral/GestaoClientes/GestaoClientesController";
import { ListarTipoRelacaoClienteController } from "../../../../../Controllers/Geral/GestaoDeCadastros/TipoRelacaoCliente/TipoRelacaoClienteControllers";
import { IContatos } from "../../../../../Interfaces/Geral/Contatos/ContatosInterfaces";
import { ICidade } from "../../../../../Interfaces/Geral/Endereco/Cidade/CidadeInterfaces";
import { BuscaCEP } from "../../../../../Services/Tools/ViaCep";
import { AlertConfirmation } from "../../../../../Tools/SweetAlerts";
import { cpfOrCnpjValidator } from "../../../../../Validations/InputValidation";
import { ValidationErr } from "../../../../../Validations/ValidationError";
import LazySelect from "../../../Forms/LazySelect";
import SearchSelect from "../../../Forms/SearchSelect";

interface ICadastrarContatoProps {
    setShow: (show: boolean) => void;
    update: () => void;
    idConta?: number;
    email?: string;
}

interface ICadastrarContatoFormData extends IContatos {
    IDRelacaoCliente: number;
    ID_CONTA: number;
}

export default function CadastrarContato(props: ICadastrarContatoProps) {
    const { register, handleSubmit, formState, getValues, setValue, control } =
        useForm<ICadastrarContatoFormData>();
    const {
        OrgInfor: { COD_ERP_INTEGRACAO },
    } = useUserInfor();

    const [bairro, setBairro] = useState<string>();
    const [ufEstado, setUfEstado] = useState<string>();

    const [cidade, setCidade] = useState<ICidade>();
    const [estadoID, setEstadoID] = useState<number>();

    const searchCliente = (searchValue: string) =>
        ListarClientesController(1, 0, {
            DS_EMAIL: "",
            DS_NOME: searchValue,
            ID_EMPREENDIMENTO: ["0"],
            ID_UNIDADE: 0,
            NR_CPF: "",
            NR_TELEFONE: "",
        }).then((res) => res.LISTA_CLIENTES);

    function handleCadastrarContatoFormSubmit(
        formData: ICadastrarContatoFormData
    ) {
        const conta = props.idConta ?? formData.ID_CONTA;

        if (COD_ERP_INTEGRACAO === "UAU" && !formData.NR_CPF) {
            AlertConfirmation(
                "CPF é um campo obrigatório no UAU",
                "Deseja prosseguir com o cadastro, sabendo que o contato não será registrado no UAU?",
                "warning"
            ).then((res) => {
                if (res.isConfirmed) cadastrar();
            });
        } else cadastrar();

        function cadastrar() {
            CadastrarContatoController(
                {
                    ...formData,
                    ID_CIDADE: cidade?.ID_CIDADE,
                    DS_BAIRRO: bairro,
                    DS_CIDADE: cidade?.DS_CIDADE,
                    DS_ESTADO: ufEstado,
                },
                conta,
                formData.IDRelacaoCliente
            ).then(() => {
                props.setShow(false);
                props.update();
            });
        }
    }

    return (
        <form
            className="w-100 align-itens-center mt-5 m-0"
            onSubmit={handleSubmit(handleCadastrarContatoFormSubmit)}
        >
            <div className="form-group row">
                {!props.idConta && (
                    <div className="col-12 mt-2">
                        <label>Cliente: *</label>
                        <Controller
                            name="ID_CONTA"
                            control={control}
                            rules={{
                                required: "Insira um cliente",
                            }}
                            render={(field) => (
                                <SearchSelect
                                    controller={searchCliente}
                                    getDS={(u) => u.DS_CONTA}
                                    getKeyValue={(u) => u.ID_CONTA}
                                    {...field}
                                />
                            )}
                        />
                    </div>
                )}

                <div className="col-12 mt-2">
                    <label>Nome: *</label>
                    <input
                        type="text"
                        name="DS_NOME"
                        className={`form-control px-0 p-2 placeholder-muted-75 ${
                            formState.errors.DS_NOME && "is-invalid"
                        }`}
                        ref={register({
                            required: "Insira o Nome do Contato",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.DS_NOME
                            ? formState.errors.DS_NOME.message
                            : ""}
                    </div>
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Email:</label>
                    <input
                        type="text"
                        name="DS_EMAIL"
                        value={props.email}
                        readOnly={!!props.email}
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                    />
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>CPF/CNPJ:</label>
                    <input
                        name="NR_CPF"
                        className={`form-control px-0 p-2 placeholder-muted-75 ${
                            formState.errors.NR_CPF ? "is-invalid" : ""
                        }`}
                        ref={register({
                            validate: (cpf) =>
                                (cpf ? cpfOrCnpjValidator(cpf) : true) ||
                                "CPF ou CNPJ inválido!",
                        })}
                    />
                    <div className="invalid-feedback">
                        {formState.errors.NR_CPF
                            ? formState.errors.NR_CPF.message
                            : ""}
                    </div>
                </div>
            </div>

            <div className="form-group row">
                <div className="col-12 col-lg-6 mt-2">
                    <label>CEP:</label>
                    <div className="input-icon input-icon-right">
                        <input
                            type="text"
                            name={`NR_CEP`}
                            className="form-control"
                            ref={register()}
                        />
                        <span
                            onClick={async () => {
                                const cep =
                                    `${getValues(`NR_CEP`)}`?.replace(
                                        /([^\d])+/gim,
                                        ""
                                    ) || "0";
                                if (cep?.length === 8) {
                                    await BuscaCEP(Number(cep))
                                        .then((InformCep) => {
                                            GetCidadeController(
                                                InformCep.localidade
                                            ).then((cidade) => {
                                                setCidade(cidade);
                                                setEstadoID(cidade.ID_ESTADO);
                                            });
                                            setValue(
                                                `DS_BAIRRO`,
                                                InformCep.bairro
                                            );
                                            setBairro(InformCep.bairro);
                                            setValue(
                                                `DS_LOGRADOURO`,
                                                InformCep.logradouro
                                            );
                                            setUfEstado(InformCep.uf);
                                        })
                                        .catch(ValidationErr);
                                }
                            }}
                        >
                            <i className="flaticon2-search-1 icon-md"></i>
                        </span>
                    </div>
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Estado:</label>
                    <LazySelect
                        controller={ListarEstadosController}
                        getDS={(e) => e.DS_ESTADO}
                        getKeyValue={(e) => e.ID_ESTADO}
                        disabled
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        value={estadoID}
                    >
                        <option></option>
                    </LazySelect>
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Cidade:</label>
                    <select
                        name="ID_CIDADE"
                        disabled
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                        value={cidade?.ID_CIDADE}
                    >
                        <option value={cidade?.ID_CIDADE}>
                            {cidade?.DS_CIDADE}
                        </option>
                    </select>
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Bairro:</label>
                    <input
                        type="text"
                        name="DS_BAIRRO"
                        placeholder={"Digite o número do telefone:"}
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                    />
                </div>
                <div className="col-12 col-lg-12 mt-2">
                    <label>Endereço:</label>
                    <input
                        type="text"
                        name="DS_LOGRADOURO"
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                    />
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Número:</label>
                    <input
                        type="text"
                        name="NR_ENDERECO"
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                    />
                </div>
                <div className="col-12 col-lg-6 mt-2">
                    <label>Complemento:</label>
                    <input
                        type="text"
                        name="DS_COMPLEMENTO_ENDERECO"
                        placeholder={"Digite o número do telefone:"}
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register()}
                    />
                </div>
            </div>

            <div className="form-group row">
                <div className="col-12 mt-2">
                    <label>Tipo de Relação com Cliente:</label>
                    <LazySelect
                        controller={ListarTipoRelacaoClienteController}
                        getDS={(trc) => trc.DS_TIPO_RELACAO_CLIENTE}
                        getKeyValue={(trc) => trc.TIPO_RELACAO_CLIENTE}
                        name="IDRelacaoCliente"
                        placeholder={"Digite o número do telefone:"}
                        className={`form-control px-0 p-2 placeholder-muted-75`}
                        ref={register({
                            required: "Insira o Tipo Relação Cliente",
                        })}
                    />
                </div>
            </div>

            <button className="btn btn-success w-100 mt-5">
                <FontAwesomeIcon icon={faPlus} className="mr-2" /> Adicionar
                Contato
            </button>
        </form>
    );
}
